var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24475 15.3346C5.82317 15.3346 4.66663 14.1781 4.66663 12.7565V4.10547C4.66663 2.21003 6.20869 0.667969 8.10413 0.667969C9.99956 0.667969 11.5416 2.21003 11.5416 4.10547V12.7565H10.6823V4.10547C10.6823 2.68389 9.5257 1.52734 8.10413 1.52734C6.68255 1.52734 5.526 2.68389 5.526 4.10547V12.7565C5.526 13.7042 6.29703 14.4753 7.24475 14.4753C8.19247 14.4753 8.9635 13.7042 8.9635 12.7565V5.82422C8.9635 5.35036 8.57799 4.96484 8.10413 4.96484C7.63027 4.96484 7.24475 5.35036 7.24475 5.82422V12.7565H6.38538V5.82422C6.38538 4.8765 7.15641 4.10547 8.10413 4.10547C9.05185 4.10547 9.82288 4.8765 9.82288 5.82422V12.7565C9.82288 14.1781 8.66633 15.3346 7.24475 15.3346Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClip);
export default __webpack_public_path__ + "static/media/ic-clip.868b4ee0515a7f507944a55bb507b90c.svg";
export { ForwardRef as ReactComponent };